import Chart from "react-apexcharts";
import { humanReadableFormatTime } from "../../../../utils/general";

const TimeSpent = ({ data=[] }) => {

    const chartData = {
        series: [
            { name: 'Spent time', data: data.map((e) => e.totalElapsedTime ) },
        ],
        options: {
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: true,
                },
                zoom: {
                    enabled: true,
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0,
                        },
                    },
                },
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        enabled: false,
                    },
                    columnWidth: "40%",
                    endingShape: "rounded",
                },
            },
            xaxis: {
                categories: data.map((e) => e.dayName )
            },
            legend: {
                position: 'right',
                offsetY: 40,
            },
            fill: {
                opacity: 1,
            },
            dataLabels: {
                enabled: false,
                formatter: function (val) {
                    return val + "%";
                },
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    colors: ["#304758"],
                },
            },
            colors: ["#333333", "#333333"],
            yaxis: {
                labels: {
                    show: false,
                    formatter: (value, index) => {
                        return humanReadableFormatTime(value);
                    },
                },
            },
        },
    };

  return <Chart options={chartData.options} series={chartData.series} type="bar" height="100%" width="100%" />;
};

export default TimeSpent;
